// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question-block {
  background-color: var(--public-qanda-background-color);
}
.question-block__content {
  max-width: 900px;
  margin: 0 auto;
}
.question-block__content .ant-form-item-label label {
  color: var(--public-qanda-label-color) !important;
}
.question-block__success-label {
  color: var(--public-qanda-label-color) !important;
}
.question-block__send-another {
  background-color: var(--public-qanda-submit-button-bg-color) !important;
  color: var(--public-qanda-submit-button-color) !important;
  border-color: var(--public-qanda-submit-button-border-color) !important;
}
.question-block__send-another:not(:disabled):hover {
  background-color: var(--public-qanda-submit-button-bg-color-hover) !important;
  color: var(--public-qanda-submit-button-color-hover) !important;
  border-color: var(--public-qanda-submit-button-border-color-hover) !important;
}
.question-block__send-another:disabled {
  opacity: 0.4;
}
.question-block__logo img {
  height: var(--navbar-logo-height-mobile);
  display: block;
}
@media (min-width: 1200px) {
  .question-block__logo img {
    height: var(--navbar-logo-height-desktop);
  }
}
.question-block__logo--desktop {
  display: none;
}
.question-block__logo--mobile {
  display: block;
}
@media (min-width: 1200px) {
  .question-block__logo--desktop {
    display: block;
  }
  .question-block__logo--mobile {
    display: none;
  }
}
.question-block__event-title {
  color: var(--public-qanda-event-title-color) !important;
}
.question-block__event-subtitle {
  color: var(--public-qanda-event-subtitle-color) !important;
}
.question-block__qna-title-container {
  margin-bottom: 1rem;
}
.question-block__qna-title {
  color: var(--public-qanda-title-color) !important;
  font-size: 20px;
  margin-bottom: 1rem;
}
.question-block__submit-button {
  background-color: var(--public-qanda-submit-button-bg-color) !important;
  color: var(--public-qanda-submit-button-color) !important;
  border-color: var(--public-qanda-submit-button-border-color) !important;
}
.question-block__submit-button:not(:disabled):hover {
  background-color: var(--public-qanda-submit-button-bg-color-hover) !important;
  color: var(--public-qanda-submit-button-color-hover) !important;
  border-color: var(--public-qanda-submit-button-border-color-hover) !important;
}
.question-block__submit-button:disabled {
  opacity: 0.4;
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/PublicQuestion/PublicQuestion.scss"],"names":[],"mappings":"AAEA;EACI,sDAAA;AADJ;AAGI;EACI,gBAAA;EACA,cAAA;AADR;AAGQ;EACI,iDAAA;AADZ;AAKI;EACI,iDAAA;AAHR;AAMI;EACI,uEAAA;EACA,yDAAA;EACA,uEAAA;AAJR;AAMQ;EACI,6EAAA;EACA,+DAAA;EACA,6EAAA;AAJZ;AAOQ;EACI,YAAA;AALZ;AAUQ;EACI,wCAAA;EACA,cAAA;AARZ;AAUY;EAJJ;IAKQ,yCAAA;EAPd;AACF;AAUQ;EACI,aAAA;AARZ;AAWQ;EACI,cAAA;AATZ;AAYQ;EACI;IACI,cAAA;EAVd;EAaU;IACI,aAAA;EAXd;AACF;AAeI;EACI,uDAAA;AAbR;AAgBI;EACI,0DAAA;AAdR;AAiBI;EACI,mBAAA;AAfR;AAkBI;EACI,iDAAA;EACA,eAAA;EACA,mBAAA;AAhBR;AAmBI;EACI,uEAAA;EACA,yDAAA;EACA,uEAAA;AAjBR;AAmBQ;EACI,6EAAA;EACA,+DAAA;EACA,6EAAA;AAjBZ;AAoBQ;EACI,YAAA;AAlBZ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
